// src/data/ResumeData.js

const ResumeData = {
  experiences: [
    {
      date: "Feb 2025- Present",
      title: "MEMBER",
      company: "CHENNAI INNOVATORS NETWORK",
      description: "Uniting Chennai's Tech Minds | Cross-College Collaboration"
    },
    {
      date: "Jan 2025- Present",
      title: "Campus Ambassador",
      company: "AXIS'25, VNIT-Nagpur",
      description: "Campus Ambassador for AXIS'25 at VNIT,Nagpur"
    },
    {
      date: "Feb 2025- Present",
      title: "Cybersecurity Intern",
      company: "THE RED USERS",
      description: "Working with Cybersecurity research"
    },
    {
      date: "Jan 2025- Present",
      title: "Cybersecurity Engineer Intern",
      company: "CyberXTron Technologies",
      description: "Working with Cybersecurity tools and research"
    },
    {
      date: "Dec 2024- Present",
      title: "Research & App Developer Intern",
      company: "Voxit Media",
      description: "Developed interactive UI components using React.native and collaborated with the design team to enhance user experience."
    },
    {
      date: "Aug 2024 - Nov 2024",
      title: "Developer",
      company: "DJ JAZZY INDIA",
      description: "built responsive websites and maintaining existing projects. Gained experience in JavaScript and CSS frameworks."
    },
    // Add more experiences as needed
  ],
  
  education: [
    {
      date: "2024 - 2028",
      degree: "B.Tech in Computer Science Engineering with specialization in CyberSecurity",
      institution: "SRM IST Chennai"
    },
    {
      date: "2022 - 2024",
      degree: "Science Stream - 11th and 12th",
      institution: "TJV MHSS"
    },
    {
      date: "2010 - 2022",
      degree: "LKG - 10th",
      institution: "TJV MHSS"
    },
    // Add more education entries as needed
  ],
  
  skills: [
    "React js",
    "JavaScript",
    "CSS",
    "Python",
    "Node.js",
    "HTML5",
    "Git",
    "Responsive Design",
    "UI/UX Design",
    "Firebase",
    "MongoDB",
    "Express.js",
    "RESTful APIs",
    "CHATGPT",
    "CyberSecurity", 
    "React Native",
    "C++",
    "C",
    "Arduino",
    "Tailwind CSS",
    "Bootstrap",
    "Material-UI",
    "sqlite3",
  "SQL",
  "Pandas",
  "Numpy"
    // Add more skills as needed
  ],
  memberat: [
    {
      date: "Feb 2025 - Present",
      title: "Member",
      role: "Board Member",
      company: "CHENNAI INNOVATORS NETWORK"
    },
    {
      date: "Jan 2025 - Present",
      title: "Technical Member , Event Coordinator",
      role: "Technical Team Member",
      company: "White Hat Hackers Club"
    },
    {
      date: "Jan 2025 - Present",
      title: "Technical Member",
      role: "Technical Team Member",
      company: "Exadata Club"
    },
    {
      date: "Jan 2025 - Present",
      title: "Technical Member",
      role: "Technical Team Member",
      company: "NextGen Intelligence Club"
    },
    {
      date: "Aug 2024 - Present",
      title: "Technical Member",
      role: "Technical Team Member",
      company: "ARROWDEV CLUB"
    },
    {
      date: "Nov 2024 - Present",
      title: "Member",
      role: "Content Team Member",
      company: "SRMIST VDP NEWSLETTER"
    },
    {
      date: "Aug 2024 - Present",
      title: "Technical Member",
      role: "Core Technical Team Member",
      company: "INCEPTOR CLUB"
    },
    // Add more experiences as needed
  ],
};

export default ResumeData;